import { render, staticRenderFns } from "./OrganizationMembersRanking.vue?vue&type=template&id=b6b56c16&scoped=true&"
import script from "./OrganizationMembersRanking.vue?vue&type=script&lang=js&"
export * from "./OrganizationMembersRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b56c16",
  null
  
)

export default component.exports